import React from 'react';


const SectionTitles = ({titleNames}) => (
    <div className="Section-Titles">{titleNames}</div>
)

export default SectionTitles